import { RudderAnalytics } from '@rudderstack/analytics-js/bundled';

interface IWindow extends Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Cypress: any;
}

interface AppInfo {
    name: string;
    namespace: string;
    version: string;
    appVersion: string;
}

class RudderStackAnalytics {
    private context: Record<string, any>;
    private rudderAnalytics: RudderAnalytics | null;
    private initialized: boolean;

    constructor() {
        this.context = {};
        this.rudderAnalytics = null;
        this.initialized = false;
    }

    init(
        appInfo: AppInfo,
        rudderStackWriteKey: string,
        rudderStackDataPlane: string,
        rudderstackApiUrl: string,
    ) {
        if (this.initialized) {
            return;
        }

        this.context = {
            app: appInfo,
            contextVersion: '2.0.0', // the version of the context should change every time these properties are adjusted
        };
        this.rudderAnalytics = new RudderAnalytics();

        if (
            rudderStackWriteKey &&
            rudderStackDataPlane &&
            !(
                (window as IWindow & typeof globalThis).Cypress ||
                process.env.JEST_WORKER_ID ||
                process.env.NODE_ENV === 'test'
            )
        ) {
            this.rudderAnalytics.load(
                rudderStackWriteKey,
                rudderStackDataPlane,
                {
                    configUrl: rudderstackApiUrl,
                    polyfillIfRequired: false,
                },
            );
            this.initialized = true;
        }
    }

    reset() {
        this.rudderAnalytics?.reset(true);
    }

    identify(identity: any) {
        this.rudderAnalytics?.identify(identity, this.context);
    }

    page(path: string) {
        this.rudderAnalytics?.page(path, path, undefined, this.context);
    }

    track(event: string, eventInfo: any) {
        this.rudderAnalytics?.track(event, eventInfo, this.context);
    }

    group(groupId: string) {
        this.rudderAnalytics?.group(groupId, undefined, this.context);
    }

    setContext(key: any, value: any) {
        this.context[key] = value;
    }
}

export type RudderStackAnalyticsType = RudderStackAnalytics;

export const rudderStackAnalytics = new RudderStackAnalytics();
